<p>setting-super-admin works!</p>
